// extracted by mini-css-extract-plugin
export default {"cartItemNamePriceWrapper":"cartItemNamePriceWrapper__ZTFkM","cartItemName":"cartItemName__ZGMwN","smaller":"smaller__YjFiM"};